import { EventedObject } from "../base/evented-object";
export class Graphic extends EventedObject {
    get geometry() {
        return this._geometry;
    }
    set geometry(value) {
        this._geometry = value;
    }
    get symbol() {
        return this._symbol;
    }
    set symbol(value) {
        this._symbol = value;
    }
    /**
     * 是否显示
     */
    get visible() {
        return this._visible;
    }
    /**
     * 是否显示
     */
    set visible(value) {
        this._visible = value;
    }
    constructor(geometry, symbol) {
        super();
        /**
         * 是否显示
         */
        this._visible = true;
        this.prev = null;
        this.next = null;
        this._geometry = geometry;
        this._symbol = symbol;
    }
    transform(origin, zoom) {
        this._geometry.transform(origin, zoom, this._symbol);
    }
    /**
       * 绘制点
       * @param {CanvasRenderingContext2D} ctx - 绘图上下文
       * @param {Projection} projection - 坐标投影转换
       * @param {Bound} extent - 当前可视范围
       * @param {Symbol} symbol - 渲染符号
       */
    draw(ctx) {
        this._geometry.draw(ctx, this._symbol);
    }
}
